// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"form_wrapper__lLoeu","row":"form_row__xf3qR","_lonely":"form__lonely__Z3wzM","switchers":"form_switchers__lbJ52","updateBtn":"form_updateBtn__EZuRa"};